<template>
	<template v-if="visible">
		<span ref="menuElement" class="fd-menu-root" :class="clazz" :style="style" @click="toggleMenu">
			<sym-icon v-if="hasIcon" :name="menu.icon" class="fd-button-icon"></sym-icon>
			<span v-if="hasTitle">{{ menu.title }}</span>
		</span>
		<menu-panel :pin-x="pin.x" :pin-y="pin.y" :menu="value" :open="!!menu.open"></menu-panel>
    </template>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor";
import type {MenuPart} from "@/types/fd/editor/Menu";
import {computed, provide, ref} from "vue";
import type {Anchor, Menu, MenuItem} from "@/types/ui/Menu";
import SymIcon from "@fd/helpers/SymIcon.vue";
import MenuPanel from "@fd/editors/menu/MenuPanel.vue";
import {onMounted, onUnmounted} from "vue";
import {calcPin, isMenu, isSelectable, type Pin, selectKey, setOpen, unselect} from "@fd/editors/menu/MenuUtils";

const uprops = defineProps({ ...editorProps });
const props = uprops as EditorProps;
//const m = computed<MenuPart>(() => props.part as MenuPart);
const { visible, clazz, style, localData, ro, value } = useEditor(props);
const menu = value.value as Menu;

const hasTitle = computed<boolean>(() => !!menu.title);
const hasIcon = computed<boolean>(() => !!menu.icon);

const menuElement = ref<HTMLSpanElement|null>(null);
const pin = computed<Pin>(() => calcPin(menuElement.value, menu.parentAnchor));


function toggleMenu(e:MouseEvent) {
	e.stopPropagation();
	setOpen(menu, !menu.open);
}

function selectTo(me: MenuItem, target: MenuItem):boolean {
	if (isMenu(me)) {
		let onPath = false;
		for (let mi of me.children) {
			if (selectTo(mi, target)) onPath = true;
		}
		if (onPath) {
			me.select = "path";
			me.open = true;
		} else {
			if (target === me) {
				me.select = "target";
				me.open = true;
			} else {
				me.select = "";
				me.open = false;
			}
		}
		return me.open;
	}
	if (isSelectable(me)) {
		if (target === me) {
			me.select = "target";
			return true;
		} else {
			me.select = "";
		}
	}
	return false;
}

function selectMenuItem(item: MenuItem) {
	debugger;
	selectTo(menu, item);
}

provide(selectKey, selectMenuItem);

function bodyClick() {
	setOpen(menu, false);
}

onMounted(() => {
	document.body.addEventListener("click", bodyClick);
});

onUnmounted(() => {
	document.body.removeEventListener("click", bodyClick)
});

</script>

<style>
.fd-menu-root {
	cursor: pointer;
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: baseline;
	color: var(--link-fg);
	user-select: none;
	-webkit-user-select: none;
}
.fd-menu-root:hover {
	color: var(--link-fg-hover);
}

.fd-menu-root:active {
	color: var(--link-fg-active);
}
</style>
